require('./accordion');
require('./circle-adjustments');
require('./hero-mobile-adjustment');
require('./items-slider');
require('./menu');
require('./modal');
require('./on-scroll');
require('./pwc');
require('./pwc_2');
require('./video-wiget');
